import { SERVER_API_URL } from "../constants/constants";
import axios from "axios";

const getAllBadgeRequestInfo = async (page, searchTerm = '', status = '', type = '', limit = 10) => {
  const getToken = localStorage.getItem("token");

  const config = {
    headers: { Authorization: `Bearer ${getToken}` },
    params: {
      page,
      limit,
      searchTerm,
      status,
      type
    }
  };
  const url = `${SERVER_API_URL}/verification/admin/verification-requests`;

  const result = await axios.get(url, config);
  return result.data;
};

const approvedBadgeRequest=async(id)=>{
    const getToken = localStorage.getItem("token");

    const config = {
      headers: { Authorization: `Bearer ${getToken}` },
    };
    const url = `${SERVER_API_URL}/admin/BadgeRequest/approvedBadgeRequest/${id}`;
  
  
    const result = await axios.patch(url, null,config);
    return result.data;
}


export {
    getAllBadgeRequestInfo,
    approvedBadgeRequest
  
}